export default {
  orange: '#cd2441',
  blue: '#387f93',
  purple: '#9163b1',
  grey: '#565d60',
  home24: {
    tipp: '#a56900',
  },
};
